import React from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import eventsRoutes from './eventsPublic/eventsRoutes'
import EventsShortcode from './eventsPublic/components/EventsShortcode'
import EventSectionShortcode from './eventsPublic/components/EventSectionShortcode'
import MembersGrid from './eventsPublic/components/MembersGrid'

const router = createBrowserRouter(eventsRoutes)

const domNode = document.getElementById('job4u-events-public')

if (domNode) {
    createRoot(domNode).render(<RouterProvider router={router} />)
}

// Shortcode-Behälter: nur die Kachelreihe, ohne Router. Ein Container kann
// mehrfach auf einer Seite stehen und trägt seine Einstellungen als
// data-Attribute (#24).
document.querySelectorAll('.job4u-events-shortcode').forEach(node => {
    const status = (node.dataset.status || 'upcoming').split(',').map(s => s.trim()).filter(Boolean)
    const limit = parseInt(node.dataset.limit, 10) || null

    createRoot(node).render(
        <EventsShortcode title={node.dataset.title || ''} status={status} limit={limit} />
    )
})

// Abschnitts-Shortcode (#177): ein Messe-Abschnitt auf einer beliebigen
// WordPress-Seite (etwa Elementor). Die Berufs-Verweise in die Themen-Seite
// sind gewöhnliche Adressen — ein Router ist dafür nicht nötig, aber die
// Abschnittskomponenten rendern Link aus react-router; darum derselbe
// RouterProvider-freie Mount wie oben, die Komponenten nutzen nur <a>.
document.querySelectorAll('.job4u-event-section-shortcode').forEach(node => {
    createRoot(node).render(
        <EventSectionShortcode
            event={node.dataset.event || ''}
            type={node.dataset.type || ''}
            title={node.dataset.title || ''}
        />
    )
})

// Logo-Raster der Mitgliederseite (#242), Shortcode [job4u_mitglieder].
document.querySelectorAll('.job4u-members-shortcode').forEach(node => {
    createRoot(node).render(<MembersGrid />)
})
